import React from 'react'
import { Link } from 'react-router-dom'
import getOtherFilters from '../../functions/getOtherFilters'
import { useFilterValues } from '../HooksOverview/useFilterValues'

export const DAY_FILTER_ID = 'time'
export const FILTER_WEEK_DAYS_ID = 'filterWeekDays'


export const getWeekOtherFilters = (filterStrings) => _.omit(filterStrings, DAY_FILTER_ID)

export const useWeekFilter = (dayFilters, filterId, currentLang) => {
    const filter = dayFilters[filterId]
    const { items } = filter
    const displayName = filter.displayName[currentLang]

    return [items, displayName]
}

export const useWeekFilterSortValue = (
    filterId,
    filterValues,
    otherFilters
) => {
    let className = ''
    let sortValue = null

    if('all' === filterId) {
        sortValue = null  
    } else {
        sortValue = `?${DAY_FILTER_ID}=${filterId}`

        if(filterValues) {
            const currentFilterValuesIndex = filterValues.indexOf(filterId)

            if(-1 !== currentFilterValuesIndex) {
                className = ' filter-active accent-color-font'
                sortValue = null
            }
        }

        sortValue = getOtherFilters(otherFilters, sortValue)
    }

    return [className, sortValue]
}

const WeekFilter = ({
    dayFilters, 
    filterStrings, 
    queryStringValues, 
    additionalClassName, 
    translation
}) => {
    const filterValues = useFilterValues(queryStringValues, DAY_FILTER_ID)
    const otherFilters = getWeekOtherFilters(filterStrings)
    
    return Object.keys(dayFilters).map((filterId, index) => {
        if(filterId === FILTER_WEEK_DAYS_ID) {
            return ''
        }

        const [items, displayName] = useWeekFilter(dayFilters, filterId, translation.currentLang)

        const [className, sortValue] = useWeekFilterSortValue(
            filterId,
            filterValues,
            otherFilters
        )
  
        return (
            items && items.length > 0 || filterId === 'all' ? (
                <Link key={index} className={additionalClassName + "-filter-button title-large" + className + ' ' + filterId} to={{search: sortValue}}>
                    {displayName}
                </Link>
            ):(
                <span key={index} className={additionalClassName + "-filter-button title-large" + className + ' filter-inactive ' + filterId}>{displayName}</span>
            )
        )
    })
}

export default WeekFilter